import { render, staticRenderFns } from "./BarChartLoadingItem.vue?vue&type=template&id=4fe9a082"
import script from "./BarChartLoadingItem.vue?vue&type=script&lang=js"
export * from "./BarChartLoadingItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports